import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";

export default function SchedulerStatusTabs({options, selectedStatus, statusCounts, onChange}) {
    return (
        <ButtonGroup>
            {options.map((option) => {
                const countKey = option.countKey || option.value || option.label;
                const count = statusCounts[countKey];
                const buttonLabel = count ? `${option.label} (${count}) ` : `${option.label}    `;

                return (
                    <ToggleButton
                        key={option.value}
                        id={`scheduler-status-${option.value}`}
                        type="radio"
                        variant={option.variant}
                        name="scheduler-status"
                        value={option.value}
                        checked={selectedStatus === option.value}
                        onChange={(event) => onChange(event.currentTarget.value)}
                    >
                        {buttonLabel}
                    </ToggleButton>
                );
            })}
        </ButtonGroup>
    );
}
